export const ufcDataState = {
    state: {
        nextScheduledEvent: null,
    },
    getters: {
        nextScheduledEvent: (state) => {
            return state.nextScheduledEvent;
        },
    },
    mutations: {
        nextScheduledEvent(state, target) {
            state.nextScheduledEvent = target;
        },
    }
};